import Alert from '~/components/Alert';
import Submit from '~/components/button/Submit';
import Divide from '~/components/Divide';
import Form from '~/components/Form';
import Page from '~/components/layout/page/Page';
import LineItem from '~/components/LineItem';
import LoadingBoundary from '~/components/LoadingBoundary';
import { useCurrencyFormatter } from '~/utils/formatters';
import PaymentSummary from './PaymentSummary';
import { useActionResult, useLoaderData } from './warrantyReview';

export default function WarrantyReviewPage() {
  const { claims, payment } = useLoaderData();
  const actionResult = useActionResult();
  const currencyFormatter = useCurrencyFormatter();

  return (
    <Page.Root title="Review These Items">
      <LoadingBoundary>
        <Page.Section title="Items">
          <Divide>
            {claims.map(
              ({
                id,
                quantity,
                lineItem: { name, imgUrl, optionsFromPlatform },
              }) => (
                <LineItem
                  variant="small"
                  key={id}
                  name={name ?? ''}
                  imgSrc={imgUrl}
                  quantity={quantity}
                  options={optionsFromPlatform}
                />
              ),
            )}
          </Divide>
        </Page.Section>

        {payment && (
          <PaymentSummary
            amount={{
              display: currencyFormatter(payment.amount),
            }}
            label={payment.label}
          />
        )}

        {actionResult && (
          <Alert
            variant="error"
            className="mt-6"
            title="An error occurred while creating the claim. Please try again later."
          >
            <p>{actionResult.message}</p>
          </Alert>
        )}
        <Form className="mt-2">
          <input type="hidden" name="payment" value={JSON.stringify(payment)} />
          <Submit>Submit Request</Submit>
        </Form>
      </LoadingBoundary>
    </Page.Root>
  );
}
